module.exports = __webpack_public_path__ + "img/14_52.802df99c.png";